import Udesk from 'Udesk';
import UdeskLocales from 'UdeskLocales';
import React, { FC, memo, useCallback, useEffect, useImperativeHandle, useState } from 'react';
import { Menu, Button, FormBuilder, Space, Empty, Spin } from 'udesk-ui';
import InspectionDetail from 'src/components/pages/components/inspection-detail';
import UdeskPagination from 'Component/common/udesk-pagination';
import UdeskDatePicker from 'Component/common/udesk-date-picker';
import type { FormProps } from 'udesk-ui/lib/form-builder/types/form';
import 'udesk-ui/lib/form/style/index.less';
import Card from '../Card';
import GradedFilter from '../GradedFilter';
import RatingFilter from '../RatingFilter';
import moment from 'moment';

let timer: any = null;
let timer2: any = null;
let timer3: any = null;

interface TemplateProps {
    sdkOptions: any;
    forwardRef?: any;
    tasksType: number;
    setTasksType: (tasksType: number) => void;
    setQualityTasksTypes: (qualityTasksTypes: any[]) => void;
    loading: boolean;
    setLoading: (loading: boolean) => void;
}

const Template: FC<TemplateProps> = memo((props) => {
    const {
        sdkOptions,
        forwardRef,
        tasksType,
        setTasksType,
        setQualityTasksTypes,
        loading,
        setLoading,
    } = props;
    const locales = UdeskLocales['current'];
    const appealLocales = locales.components.pages.appealSdk;

    const [formRef] = FormBuilder.useForm();
    const [selectedTaskId, setSelectedTaskId] = useState<number>(0);

    const [listLoading, setListLoading] = useState<boolean>(false);
    const [isInit, setIsInit] = useState<boolean>(true);
    const [dialogRemarkList, setDialogRemarkList] = useState<any[]>([]);
    const [detail, setDetail] = useState<any>({});

    const [pointChildrenComputer, setPointChildrenComputer] = useState<any>({});
    const [pointChildrenPerson, setPointChildrenPerson] = useState<any>({});

    const [dateRange, setDateRange] = useState<any>({
        beginTime: '',
        endTime: '',
    });

    const [paging, setPage] = useState<any>({
        pageNum: 1,
        pageSize: 20,
        total: 0,
    });
    const [taskList, setTaskList] = useState<any[]>([]);
    const [taskIdsOptions, setTaskIdsOptions] = useState<any[]>([]);
    const [showHit, setShowHit] = useState<0 | 1>(0);

    const isTicket = tasksType === Udesk.enums.inspectDataSources.ticket.id;
    const isMixedType = tasksType === Udesk.enums.inspectDataSources.mixedType.id;
    const isSurvey = tasksType === Udesk.enums.inspectDataSources.survey.id;

    const showHitChange = (showHit) => {
        setShowHit(showHit ? 1 : 0);
    };
    const handMarkMap = () => {};

    const onSelect = ({ key }: any) => {
        setSelectedTaskId(key * 1);
        changeReadStatus(key, taskList);
    };
    const changeReadStatus = useCallback(
        (key, taskList) => {
            const item = taskList.find((i) => i.dataId === key * 1);
            if (!item) return;
            if (item.fieldValueMap['f_2'] === Udesk.enums.appealCheckStatus.unread.name) {
                // let url = Udesk.business.apiPath.concatApiPath(`/open_api_v1/inspection/${task.dataId}/read`, sdkOptions);
                // Udesk.ajax.post(url)
                Udesk.business.sdkAjax
                    .post(`/open_api_v1/inspection/${item.dataId}/read`, sdkOptions, { props })
                    .then(
                        () => {
                            item.fieldValueMap['f_2'] = Udesk.enums.appealCheckStatus.readed.name;
                            setTaskList([...taskList]);
                        },
                        (reason) => {
                            Udesk.ui.notify.error(
                                reason.errorMsg ||
                                    /* 接口请求异常，请稍后再试 */ UdeskLocales['current'].pages
                                        .appealCheckingTask.sdk.index
                                        .interfaceRequestExceptionPleaseTryAgainLater
                            );
                        }
                    );
            }
        },
        [props, sdkOptions]
    );

    const getParams = useCallback(
        (searchParams) => {
            if (!searchParams) {
                searchParams = {};
            }
            if (Array.isArray(searchParams.time) && searchParams.time[0] && searchParams.time[1]) {
                searchParams.beginTime = searchParams.time[0];
                searchParams.endTime = searchParams.time[1];
            }
            const { graded = {}, ...otherParams } = searchParams;
            let params = {
                ...paging,
                inspectDataSource: tasksType,
                ...otherParams,
                ...graded,
            };
            let querryDateRange = dateRange;
            if (
                isInit &&
                sdkOptions?.props?.defaultDateRange &&
                sdkOptions?.props?.defaultDateRange.length
            ) {
                let dateRange = sdkOptions.props.defaultDateRange;
                querryDateRange = {
                    beginTime: dateRange[0] ? dateRange[0].format('YYYY-MM-DD') + ' 00:00:00' : '',
                    endTime: dateRange[1] ? dateRange[1].format('YYYY-MM-DD') + ' 23:59:59' : '',
                };
                setDateRange(querryDateRange);
                setIsInit(false);
                params = { ...params, ...querryDateRange };
            }
            return params;
        },
        [dateRange, isInit, paging, sdkOptions.props.defaultDateRange, tasksType]
    );

    const searchTasks = useCallback(
        (listParams, cb) => {
            if (timer2) {
                clearTimeout(timer2);
            }

            timer2 = setTimeout(() => {
                Udesk.business.sdkAjax
                    .get('open_api_v1/task-list-v1', sdkOptions, { props }, listParams)
                    .then(
                        (resp) => {
                            cb(resp);
                        },
                        (reason) => {
                            Udesk.ui.notify.error(
                                reason.errorMsg ||
                                    /* 接口请求异常，请稍后再试 */ UdeskLocales['current'].pages
                                        .appealCheckingTask.sdk.index
                                        .interfaceRequestExceptionPleaseTryAgainLater
                            );
                        }
                    );
            }, 500);
        },
        [props, sdkOptions]
    );

    const setTaskIdsOptionsFromAjax = (resp) =>
        setTaskIdsOptions(resp.data?.map?.((i) => ({ label: i.name, value: i.id })) ?? []);

    const onSelectSearchTask = (value) => {
        searchTasks(
            {
                keywords: value,
                inspectDataSource: tasksType,
            },
            setTaskIdsOptionsFromAjax
        );
    };

    const searchList = useCallback(
        (searchParams: any = {}, needResetSelectTaskId = false) => {
            const params = getParams(searchParams);
            setListLoading(true);
            Udesk.business.sdkAjax
                .post('open_api_v1/task/caseLibrary', sdkOptions, { props }, params)
                .then(
                    (resp) => {
                        const newTaskList = resp.data?.fieldDataList || [];
                        setTaskList(newTaskList);
                        if ((resp.data?.fieldDataList?.length ?? 0) > 0) {
                            if (needResetSelectTaskId) {
                                setSelectedTaskId(resp.data.fieldDataList[0].dataId);
                                changeReadStatus(resp.data.fieldDataList[0].dataId, newTaskList);
                            }
                        } else {
                            setSelectedTaskId(0);
                        }
                        setPage(resp.paging);
                        setListLoading(false);
                    },
                    (reason) => {
                        Udesk.ui.notify.error(
                            reason.errorMsg ||
                                /* 接口请求异常，请稍后再试 */ UdeskLocales['current'].pages
                                    .appealCheckingTask.sdk.index
                                    .interfaceRequestExceptionPleaseTryAgainLater
                        );
                        setListLoading(false);
                    }
                );
        },
        [changeReadStatus, getParams, props, sdkOptions]
    );
    const searchListFromForm = (searchParams: any = {}) => {
        const { rating, ...params } = searchParams;
        searchList(
            {
                ...params,
                ...rating,
                pageNum: 1,
            },
            true
        );
    };

    const pageChanged = (pageNum) => {
        setPage({
            ...paging,
            pageNum,
        });
        const values = formRef.getFieldsValue();
        searchList({
            pageNum,
            ...values,
        });
    };
    const onTasksTypeChange = useCallback(
        (activeKey) => {
            setTasksType(activeKey * 1);

            formRef.setFieldsValue({
                taskIds: undefined,
            });

            const values = formRef.getFieldsValue();

            setPage({
                ...paging,
                pageNum: 1,
            });
            searchList(
                {
                    inspectDataSource: activeKey * 1,
                    pageNum: 1,
                    ...values,
                },
                true
            );
            const listParams = {
                inspectDataSource: activeKey,
            };
            searchTasks(listParams, setTaskIdsOptionsFromAjax);
        },
        [formRef, paging, searchList, searchTasks, setTasksType]
    );

    const refreshList = () => {
        const formValues = formRef.getFieldsValue();
        searchList(formValues);
    };

    useEffect(() => {
        if (!selectedTaskId) return;
        setLoading(true);
        if (timer) {
            clearTimeout(timer);
        }
        timer = setTimeout(() => {
            Udesk.business.sdkAjax
                .get(`open_api_v1/inspection/${selectedTaskId}`, sdkOptions, { props })
                .then(
                    (resp) => {
                        let pointChildrenComputer = {};
                        let pointChildrenPerson = {};
                        setSelectedTaskId(resp.data.id);
                        const {
                            // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
                            relatedInspectionDataExtension = {},
                            // related,
                            ...detail
                        } = resp.data;

                        //单句备注
                        setDialogRemarkList(detail.remarkList || []);
                        let task = { ...detail };

                        //质检点（一级分类）列表
                        if (task.pointCategoryList && task.pointCategoryList.length > 0) {
                            task.pointCategoryList.forEach((item) => {
                                //一级分类下有二级分类
                                if (item.children) {
                                    item.children.forEach((items) => {
                                        //二级分类下有质检点
                                        if (items.pointDataList) {
                                            items.pointDataList.forEach((itemss) => {
                                                //质检点有人工标记的高亮（？不确定）
                                                if (itemss.handMarkHighlightSeqMap) {
                                                    if (itemss.handMarkHighlightSeqMap[1]) {
                                                        itemss.handMarkHighlightSeqMap[1].forEach(
                                                            (itemsss) => {
                                                                if (pointChildrenPerson[itemsss]) {
                                                                    pointChildrenPerson[
                                                                        itemsss
                                                                    ].push({
                                                                        id: itemss.pointId,
                                                                        name: itemss.name,
                                                                    });
                                                                } else {
                                                                    pointChildrenPerson = {
                                                                        ...pointChildrenPerson,
                                                                        [itemsss]: [
                                                                            {
                                                                                id: itemss.pointId,
                                                                                name: itemss.name,
                                                                            },
                                                                        ],
                                                                    };
                                                                }
                                                            }
                                                        );
                                                    }
                                                    if (itemss.handMarkHighlightSeqMap[2]) {
                                                        itemss.handMarkHighlightSeqMap[2].forEach(
                                                            (itemsss) => {
                                                                if (
                                                                    pointChildrenComputer[itemsss]
                                                                ) {
                                                                    pointChildrenComputer[
                                                                        itemsss
                                                                    ].push({
                                                                        id: itemss.pointId,
                                                                        name: itemss.name,
                                                                    });
                                                                } else {
                                                                    pointChildrenComputer = {
                                                                        ...pointChildrenComputer,
                                                                        [itemsss]: [
                                                                            {
                                                                                id: itemss.pointId,
                                                                                name: itemss.name,
                                                                            },
                                                                        ],
                                                                    };
                                                                }
                                                            }
                                                        );
                                                    }
                                                }
                                            });
                                        }
                                    });
                                }
                            });
                        }
                        // setPointCategoryList(task.pointCategoryList);
                        setDetail(task);
                        setPointChildrenComputer(pointChildrenComputer);
                        setPointChildrenPerson(pointChildrenPerson);
                        setLoading(false);
                    },
                    (reason) => {
                        Udesk.ui.notify.error(
                            reason.errorMsg ||
                                /* 接口请求异常，请稍后再试 */ UdeskLocales['current'].pages
                                    .appealCheckingTask.sdk.index
                                    .interfaceRequestExceptionPleaseTryAgainLater
                        );
                        setLoading(false);
                    }
                );

            timer = null;
        }, 500);
    }, [selectedTaskId]);

    const [caseLibraryOptions, setCaseLibraryOptions] = useState<any[]>([]);

    const searchCaseLibrary = useCallback(
        (params) => {
            if (timer3) {
                clearTimeout(timer3);
            }

            timer3 = setTimeout(() => {
                Udesk.business.sdkAjax
                    .post('open_api_v1/caseLibraryCategory', sdkOptions, { props }, params)
                    .then(
                        (resp) => {
                            setCaseLibraryOptions(
                                (resp.data || []).map((item) => ({
                                    label: item.name,
                                    value: item.id,
                                }))
                            );
                        },
                        (reason) => {
                            Udesk.ui.notify.error(
                                reason.errorMsg ||
                                    /* 接口请求异常，请稍后再试 */ UdeskLocales['current'].pages
                                        .appealCheckingTask.sdk.index
                                        .interfaceRequestExceptionPleaseTryAgainLater
                            );
                        }
                    );
            }, 500);
        },
        [props, sdkOptions]
    );

    const config: FormProps = {
        initialValues: {
            ...sdkOptions?.props,
        },
        layout: 'inline',
        onFinish: searchListFromForm,
        customComponents: { UdeskDatePicker, GradedFilter, RatingFilter },
        fields: [
            {
                name: 'time',
                label: isTicket
                    ? /* 开始时间 */ locales.pages.appealCheckingTask.sdk.index.startTime
                    : isMixedType || isSurvey
                    ? /* 时间 */ locales.pages.appealCheckingTask.sdk.index.time
                    : appealLocales.time,
                type: 'UdeskDatePicker',
                props: {
                    defaultValue: sdkOptions?.props.defaultDateRange
                        ? sdkOptions?.props.defaultDateRange.map(
                              (i, index) =>
                                  `${i.format('YYYY-MM-DD')} ${
                                      index === 0 ? '00:00:00' : '23:59:59'
                                  }`
                          )
                        : [
                              moment().subtract(1, 'M').format('YYYY-MM-DD') + ' 00:00:00',
                              moment().format('YYYY-MM-DD') + ' 23:59:59',
                          ],
                    disabled: sdkOptions?.props.dateRangeDisabled,
                    showTime: true,
                    format: 'YYYY-MM-DD HH:mm:ss',
                },
            },
            {
                name: 'externalId',
                label:
                    tasksType === Udesk.enums.inspectDataSources.voiceCall.id
                        ? appealLocales.externalIdCall
                        : isTicket
                        ? /* 工单编号 */ locales.pages.appealCheckingTask.sdk.index.workOrderNo
                        : isMixedType || isSurvey
                        ? /* 唯一记录ID */ locales.pages.appealCheckingTask.sdk.index.uniqueRecordID
                        : tasksType === Udesk.enums.inspectDataSources.videoCall.id
                        ? /* 视频会话ID */ locales.pages.appealCheckingTask.sdk.index.videoSessionID
                        : appealLocales.externalIdText,
                type: 'Input',
                props: {
                    placeholder: locales.labels.pleaseEnter,
                },
            },
            {
                name: 'taskIds',
                label: appealLocales.taskIds,
                type: 'Select',
                props: {
                    style: {
                        width: 250,
                    },
                    mode: 'multiple',
                    allowClear: true,
                    options: taskIdsOptions,
                    onSearch: onSelectSearchTask,
                    filterOption: false,
                    maxTagCount: 'responsive',
                    placeholder: locales.labels.pleaseSelect,
                    onChange: (value) => {
                        formRef.setFieldsValue({
                            caseLibraryIdList: undefined,
                        });
                        if (value?.length) {
                            searchCaseLibrary(value);
                        } else {
                            setCaseLibraryOptions([]);
                        }
                    },
                },
            },
            {
                name: 'caseLibraryIdList',
                label: /* 所属案例库 */ UdeskLocales['current'].pages.appealCheckingTask.sdk
                    .components.caseLibView.index.caseLibrary,
                type: 'Select',
                props: {
                    style: {
                        width: 250,
                    },
                    allowClear: true,
                    options: caseLibraryOptions,
                    // onSearch: onSelectSearchTask,
                    mode: 'multiple',
                    maxTagCount: 'responsive',
                    filterOption: false,
                    placeholder: locales.labels.pleaseSelect,
                },
            },
        ],
        footerRender: () => (
            <Space>
                <Button type="primary" htmlType="submit">
                    {locales.labels.query}
                </Button>
                <Button
                    onClick={() => {
                        formRef.resetFields();
                        setCaseLibraryOptions([]);
                    }}
                >
                    {locales.labels.reset}
                </Button>
            </Space>
        ),

        // onFinish: onFinish,
    };

    useEffect(() => {
        Udesk.business.sdkAjax.get(`open_api_v1/company`, sdkOptions, { props }).then(
            (resp) => {
                const company = resp.data;
                let qualityTasksTypes: any[] = [];
                if (company.enabledCallInspect) {
                    qualityTasksTypes.push(Udesk.enums.inspectDataSources.voiceCall);
                }
                if (company.enabledImInspect) {
                    qualityTasksTypes.push(Udesk.enums.inspectDataSources.textDialogue);
                }
                // if (company.enabledWeComInspect) {
                //     qualityTasksTypes.push(Udesk.enums.inspectDataSources.wechatDialogue);
                // }
                // if (company.enabledWeComVoiceInspect) {
                //     qualityTasksTypes.push(Udesk.enums.inspectDataSources.wechatRadio);
                // }
                if (company.enabledTicket) {
                    qualityTasksTypes.push(Udesk.enums.inspectDataSources.ticket);
                }
                if (company.enableVideoInspect) {
                    qualityTasksTypes.push(Udesk.enums.inspectDataSources.videoCall);
                }
                qualityTasksTypes.push(Udesk.enums.inspectDataSources.mixedType);
                // if (company.enabledSurveyInspect) {
                //     qualityTasksTypes.push(Udesk.enums.inspectDataSources.survey);
                // }
                // if (company.enabledFeiShuInspect) {
                // qualityTasksTypes.push(Udesk.enums.inspectDataSources.feishuGroup);
                // }
                if (company.enabledMallInspect) {
                    qualityTasksTypes.push(Udesk.enums.inspectDataSources.taobao);
                }
                setQualityTasksTypes(qualityTasksTypes);
                const tasksType = qualityTasksTypes[0].id;
                setTasksType(tasksType);
                const values = formRef.getFieldsValue();
                searchList({ ...values, inspectDataSource: tasksType }, true);
                const listParams = {
                    inspectDataSource: tasksType,
                };
                searchTasks(listParams, setTaskIdsOptionsFromAjax);
            },
            (reason) => {
                Udesk.ui.notify.error(
                    reason.errorMsg ||
                        /* 接口请求异常，请稍后再试 */ UdeskLocales['current'].pages
                            .appealCheckingTask.sdk.index
                            .interfaceRequestExceptionPleaseTryAgainLater
                );
                setIsInit(false);
                setLoading(false);
            }
        );
    }, []);

    useImperativeHandle(
        forwardRef,
        () => {
            return {
                onTasksTypeChange,
            };
        },
        [onTasksTypeChange]
    );

    return (
        <>
            <div className="appeal-checking-task-page-filter">
                <FormBuilder {...config} form={formRef} />
            </div>

            <div className="appeal-checking-task-page-body">
                <div className="appeal-checking-task-page-left">
                    {(taskList?.length ?? 0) > 0 ? (
                        <React.Fragment>
                            <Spin spinning={listLoading}>
                                <div className="appeal-checking-task-page-left-list">
                                    <Menu selectedKeys={[`${selectedTaskId}`]} onSelect={onSelect}>
                                        {taskList.map((item) => {
                                            return (
                                                <Menu.Item key={item.dataId}>
                                                    <Card item={item.fieldValueMap} />
                                                </Menu.Item>
                                            );
                                        })}
                                    </Menu>
                                </div>
                            </Spin>
                            <div className="appeal-checking-task-page-left-page">
                                <UdeskPagination
                                    current={paging.pageNum}
                                    pageSize={paging.pageSize}
                                    total={paging.total}
                                    simple={true}
                                    showSizeChanger={false}
                                    onChange={pageChanged}
                                />
                            </div>
                        </React.Fragment>
                    ) : (
                        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                    )}
                </div>

                <div className="appeal-checking-task-page-right">
                    {selectedTaskId ? (
                        <React.Fragment>
                            <InspectionDetail
                                // evaluateChange={actions.evaluateChange}
                                resetStatus={false}
                                handMarkMap={handMarkMap}
                                pointChildrenComputer={pointChildrenComputer}
                                pointChildrenPerson={pointChildrenPerson}
                                // keywords={sdkOptions.props._keywords}
                                testSetList={null}
                                testSetListFlag={false}
                                caseBaseStatus={true}
                                // onUpdate={actions.onUpdate}
                                id={detail.id}
                                // caseBase={caseBase}
                                // caseLibraryId={location.search}
                                taskId={detail.taskId}
                                // hasFeature={hasFeature}
                                detail={detail}
                                // smartTags={smartTags}
                                // changeList={changeList}
                                // qualityCheckScoreSaving={qualityCheckScoreSaving}
                                // onQualityCheckScoreCancel={actions.qualityCheckScoreCanceled}
                                // onQualityCheckScoreSave={actions.qualityCheckScoreSaved}
                                // onQualityCheckScoreSubmit={actions.qualityCheckScoreSubmitted}
                                // relatedDatas={relatedDatas}
                                // relatedDatasPaging={relatedDatasPaging}
                                // parentLoadMore={actions.parentLoadMore}
                                // relatedLoading={relatedLoading}
                                dialogRemarkList={dialogRemarkList}
                                // changeDialogRemarkList={actions.changeDialogRemarkList}
                                // querryChangeList={actions.querryChangeList}
                                // querrySmartTags={actions.querrySmartTags}
                                isWechatQa={false}
                                // changeToHighlightItemsCallDetail={related ? actions.changeCallDetail : noop}
                                // onUpdated={actions.onUpdated}
                                // refresh={actions.reloadAsyncModel}
                                // rerenderOptimization={true}
                                // requestRelatedRecords={actions.requestRelatedRecords}
                                // relatedRecordsLoading={relatedRecordsLoading}
                                loading={loading}
                                isAppeal={true}
                                // complaintList={complaintList}
                                // onComplainPointListChange={onComplainPointListChange}
                                // complaintHistory={complaintHistory}
                                appealSdkOptions={sdkOptions}
                                // refershHistory={getComplainHistory}
                                refreshList={refreshList}
                                showHit={showHit}
                                onShowHitChange={showHitChange}
                                isCaseLibInAppeal={true}
                            />
                        </React.Fragment>
                    ) : (
                        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                    )}
                </div>
            </div>
        </>
    );
});

export default Template;
